module.exports = __webpack_public_path__ + "fonts/Roboto-Light.b6e1d0f.woff2";